import { useTranslation } from "react-i18next";
import { useTheme } from "@hooks/useTheme";
import { CheckIcon } from "@components/Icons";
import { isVexProcessed } from "@constants/vex";
import SeverityBadge from "./SeverityBadge";

const CveListPanel = ({
  items = [],
  selectedKey,
  onSelect,
  "data-testid": dataTestId = "cve-list-panel",
}) => {
  const { t } = useTranslation();
  const { colors } = useTheme();

  const isReviewed = (item) => isVexProcessed(item?.vexStatus);

  return (
    <div
      className={`flex h-full min-h-0 flex-col rounded-lg ${colors.bgInput} ${colors.borderPrimary} border`}
      data-testid={dataTestId}
    >
      <div className="px-4 py-3 flex-shrink-0">
        <h3 className={`text-sm font-semibold ${colors.textPrimary}`} data-testid={`${dataTestId}-title`}>
          {t("status.vex-cve-count", { count: items.length })}
        </h3>
      </div>

      <div className="flex-1 min-h-0 overflow-y-auto px-3 pb-3 space-y-2" data-testid={`${dataTestId}-list`}>
        {items.length === 0 ? (
          <div className={`text-sm text-center py-6 ${colors.textSecondary}`}>{t("common.no-data-to-display")}</div>
        ) : (
          items.map((item) => {
            const isSelected = item.key === selectedKey;
            return (
              <button
                key={item.key}
                type="button"
                onClick={() => onSelect(item)}
                data-testid={`${dataTestId}-item-${item.key}`}
                className={`flex w-full items-center gap-2 rounded-lg border px-3 py-2.5 text-left transition-colors ${colors.bgModal} ${
                  isSelected
                    ? colors.borderActiveDashed
                    : `${colors.borderPrimary} ${colors.borderHoverPrimary}`
                }`}
              >
                <span className="flex min-w-0 flex-1 items-center gap-1.5">
                  {isReviewed(item) && (
                    <CheckIcon
                      size={14}
                      className="flex-shrink-0 text-green-500"
                      title={t("status.vex-item-reviewed", "Reviewed")}
                      aria-label={t("status.vex-item-reviewed", "Reviewed")}
                      data-testid={`${dataTestId}-reviewed-${item.key}`}
                    />
                  )}
                  <span
                    className={`min-w-0 truncate text-sm font-medium ${isSelected ? colors.textActive : colors.textPrimary}`}
                    title={item.cve}
                  >
                    {item.cve}
                  </span>
                </span>
                <SeverityBadge severity={item.severity} data-testid={`${dataTestId}-severity-${item.key}`} />
              </button>
            );
          })
        )}
      </div>
    </div>
  );
};

export default CveListPanel;
